import { render, staticRenderFns } from "./NextMoveInterestsScores.vue?vue&type=template&id=215e060b&scoped=true"
import script from "./NextMoveInterestsScores.vue?vue&type=script&lang=ts"
export * from "./NextMoveInterestsScores.vue?vue&type=script&lang=ts"
import style0 from "./NextMoveInterestsScores.vue?vue&type=style&index=0&id=215e060b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215e060b",
  null
  
)

export default component.exports